import { AxiosResponse } from 'axios';
import paramsSerializer from '~/config/axios/paramSerializer';
import { ISummarySaleStatement, SaleStatement } from '~/domain/api';
import {
  IPagedSalesStatementReportParams,
  ISalesStatementCardsPanel,
  ISalesStatementExportReportParams,
  ISalesStatementExportResponse,
  ISalesStatementReportParams,
  ISalesStatementSummaryExportReportParams,
} from '~/domain/model/SalesStatement/SalesStatement';
import { apiReport } from '~/services/api';

export interface IResponseTable extends AxiosResponse {
  data: {
    totalCount: number;
    results: SaleStatement[];
  };
}

export interface IResponseSummaryTable extends AxiosResponse {
  data: {
    totalCount: number;
    results: ISummarySaleStatement[];
  };
}

export async function getTable(params: IPagedSalesStatementReportParams): Promise<IResponseTable> {
  return apiReport.post('sales-statement-report', params, { paramsSerializer });
}

export async function getSummaryTable(
  params: IPagedSalesStatementReportParams,
): Promise<IResponseSummaryTable> {
  return apiReport.post('sales-statement-report/summary', params, {
    paramsSerializer,
  });
}

export async function postSalesStatementExport(
  params: ISalesStatementExportReportParams,
): Promise<AxiosResponse<ISalesStatementExportResponse>> {
  return apiReport.post('/sales-statement-report/export', params, { paramsSerializer });
}

export async function salesStatementIntermediationSummaryExport(
  params: ISalesStatementSummaryExportReportParams,
): Promise<AxiosResponse<ISalesStatementExportResponse>> {
  return apiReport.post('/sales-statement-report/export-summary', params, {
    paramsSerializer,
  });
}

export async function salesStatementKlokSummaryExport(
  params: ISalesStatementSummaryExportReportParams,
): Promise<AxiosResponse<ISalesStatementExportResponse>> {
  return apiReport.post('/sales-statement-report/export-summary', params, {
    paramsSerializer,
  });
}

export async function fetchSaleStatementCardPanel(
  params: ISalesStatementReportParams,
): Promise<AxiosResponse<ISalesStatementCardsPanel>> {
  return apiReport.post('/sales-statement-report/card', params, { paramsSerializer });
}
